import { xlCol } from "../../../common/constants";

export const RouteMasterHeaders = [
  { header: "SN", translationKey: "gsSN", field: "SN", xlCol: xlCol, weight: 40 },
  { header: "City Name", translationKey: "cityName", field: "Cityname", xlCol: xlCol, weight: 90 },
  { header: "Route Zone", translationKey: "rmRouteZone", field: "RouteZone", xlCol: xlCol, weight: 90 },
  { header: "Route Name", translationKey: "rmRouteName", field: "RouteName", xlCol: xlCol, weight: 100 },
  { header: "Route Area", translationKey: "rmRouteArea", field: "RouteArea", xlCol: xlCol, weight: 180 },
  { header: "Modified By", translationKey: "gsModBy", field: "Modifiedby", xlCol: xlCol, weight: 110 },
  { header: "Modified Date & Time", translationKey: "gsModDt", field: "ModifiedDateTime", xlCol: xlCol, weight: 140 },
  { header: "Status", translationKey: "gsStatus", field: "Status_view", xlCol: xlCol, weight: 70, align: 'center' },
  { header: "Edit", translationKey: "gsEdit", field: "Edit", xlCol: xlCol, weight: 20, ViewOnly: true, align: 'center' }
];

export const RouteMasterHeaFilterHeaders = [
  { field: 'selCity', header: 'City', translationKey: 'rmCity', textAlign: 'left' },
  { field: 'routeZone', header: 'Route Zone', translationKey: 'rmRouteZone', textAlign: 'left' },
  { field: 'Status', header: 'Status', translationKey: 'gsStatus', textAlign: 'left' },
]
export const routeZones = [
  { id: 0, name: "All", translationKey: "gsAll" },
  { id: 1, name: "North (N)", translationKey: "rmNorth" },
  { id: 2, name: "East (E)", translationKey: "rmEast" },
  { id: 3, name: "South (S)", translationKey: "rmSouth" },
  { id: 4, name: "West (W)", translationKey: "rmWest" },
  { id: 5, name: "Northeast (NE)", translationKey: "rmNortheast" },
  { id: 6, name: "Southeast (SE)", translationKey: "rmSoutheast" },
  { id: 7, name: "Northwest (NW)", translationKey: "rmNorthwest" },
  { id: 8, name: "Southwest (SW)", translationKey: "rmSouthwest" }
];
export const statusList = [
  { id: 1, name: 'Active', translationKey: 'gsActive' },
  { id: 0, name: 'Inactive', translationKey: 'gsInactive' },
  { id: -1, name: 'All', translationKey: 'gsAll' }
]
